import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ClientConfig } from '../models/ClientConfig';
import store from '@/lib/redux/store';

export const clientConfigApi = createApi({
    reducerPath: 'clientConfigApi',
    keepUnusedDataFor: 86400,
    baseQuery: fetchBaseQuery({ baseUrl: '/' }),
    endpoints: (builder) => ({
        clientConfig: builder.query<ClientConfig, void>({
            query: () => 'config.json',
        }),
    }),
})

export const { useClientConfigQuery } = clientConfigApi

export const getClientConfig = () => {
    const state = store.getState()
    const select = clientConfigApi.endpoints.clientConfig.select();
    return select(state);
}
